module.exports = __webpack_public_path__ + "static/media/money.3c18d916.svg";